
export const FileEndpoint = import.meta.env.VITE_FILE_URL;
